import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "merchants-page" };
const _hoisted_2 = { class: "merchants-layout" };
const _hoisted_3 = { class: "merchants-list-panel" };
const _hoisted_4 = { class: "search-box" };
const _hoisted_5 = { class: "merchants-list" };
const _hoisted_6 = {
    key: 0,
    class: "merchant-items"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_10 = { class: "merchant-details-panel" };
const _hoisted_11 = {
    key: 0,
    class: "details-content"
};
const _hoisted_12 = { class: "detail-header" };
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "top-actions" };
const _hoisted_15 = { class: "form-row" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = { class: "classification-row" };
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
    key: 0,
    class: "form-group"
};
const _hoisted_21 = {
    key: 0,
    class: "regex-results"
};
const _hoisted_22 = { class: "regex-table" };
const _hoisted_23 = { class: "form-row" };
const _hoisted_24 = { class: "form-group" };
const _hoisted_25 = { class: "form-row" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = { class: "form-group" };
const _hoisted_28 = { class: "checkbox-row" };
const _hoisted_29 = { class: "form-group checkbox" };
const _hoisted_30 = { class: "form-group checkbox" };
const _hoisted_31 = { class: "form-group checkbox" };
const _hoisted_32 = {
    key: 1,
    class: "form-group"
};
const _hoisted_33 = { class: "voucher-display" };
const _hoisted_34 = { class: "form-group" };
const _hoisted_35 = { class: "classification-row" };
const _hoisted_36 = ["value"];
const _hoisted_37 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_38 = { class: "drawer-header" };
const _hoisted_39 = { class: "drawer-content" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    key: 1,
    class: "cat-btn parent-cat"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = { class: "modal-header" };
const _hoisted_44 = { class: "modal-body" };
const _hoisted_45 = { class: "modal-footer" };
import { ref, computed, reactive, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import { cleanBrandName } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MerchantsPage',
    setup(__props) {
        const admin = useAdmin();
        const merchants = ref([]);
        const selectedMerchant = ref(null);
        const editingData = reactive({});
        const searchQuery = ref('');
        const transactionClassifications = ref([]);
        const showClassifications = ref(false);
        const showDeleteConfirm = ref(false);
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const regexMatches = ref(null);
        const testingRegex = ref(false);
        const groupedClassifications = computed(() => {
            const groups = new Map();
            for (const row of transactionClassifications.value) {
                const name = row.mgClassification;
                if (!name)
                    continue;
                if (!groups.has(name))
                    groups.set(name, { name, parent: null, children: [] });
                const g = groups.get(name);
                if (row.mgSubClassification)
                    g.children.push(row);
                else
                    g.parent = row;
            }
            return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name));
        });
        const filteredMerchants = computed(() => {
            if (!searchQuery.value.trim()) {
                return merchants.value;
            }
            const query = searchQuery.value.toLowerCase();
            return merchants.value.filter((m) => m.name.toLowerCase().includes(query));
        });
        const discountString = computed(() => {
            const discount = selectedMerchant.value ? selectedMerchant.value.discount : null;
            if (!discount)
                return '';
            let type = '';
            if (discount.online && discount.inStore) {
                type = 'Online & In Store';
            }
            else if (discount.online) {
                type = 'Online';
            }
            else if (discount.inStore) {
                type = 'In Store';
            }
            return discount.discountPercentage + '% ' + type;
        });
        function getBrandLogoUrl(name) {
            if (!name)
                return require('@/assets/round3.png');
            return 'https://api.sysodev.link/BrandLogos/' + cleanBrandName(name).replace(/[ /]/g, '+');
        }
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message;
            showErrorToast.value = true;
        }
        function loadMerchants() {
            admin.getMerchants((result) => {
                merchants.value = result;
            });
        }
        function testRegex() {
            testingRegex.value = true;
            admin.testMerchantRegex(editingData.regex, (result) => {
                regexMatches.value = result || [];
                testingRegex.value = false;
            }, (error) => {
                testingRegex.value = false;
                showError(error);
            });
        }
        function selectMerchant(merchant) {
            selectedMerchant.value = merchant;
            regexMatches.value = null;
            Object.assign(editingData, {
                name: merchant.name,
                regex: merchant.regex,
                regexExclude: merchant.regexExclude || '',
                lowerLimit: merchant.lowerLimit,
                upperLimit: merchant.upperLimit,
                utilityProvider: merchant.utilityProvider || false,
                switchDealAvailable: merchant.switchDealAvailable || false,
                notRecurring: merchant.notRecurring || false,
                transactionClassification: merchant.transactionClassification || null,
                setTransactionClassificationID: merchant.transactionClassification ? merchant.transactionClassification.id : null
            });
        }
        function duplicateMerchant() {
            selectedMerchant.value = {
                id: null,
                name: editingData.name + ' (copy)',
                regex: editingData.regex,
                regexExclude: editingData.regexExclude,
                lowerLimit: editingData.lowerLimit,
                upperLimit: editingData.upperLimit,
                utilityProvider: editingData.utilityProvider,
                switchDealAvailable: editingData.switchDealAvailable,
                notRecurring: editingData.notRecurring
            };
            Object.assign(editingData, {
                name: editingData.name + ' (copy)',
                setTransactionClassificationID: editingData.setTransactionClassificationID
            });
        }
        function createNewMerchant() {
            regexMatches.value = null;
            selectedMerchant.value = {
                id: null,
                name: '',
                regex: '',
                regexExclude: '',
                lowerLimit: null,
                upperLimit: null,
                utilityProvider: false,
                switchDealAvailable: false,
                notRecurring: false
            };
            Object.assign(editingData, {
                name: '',
                regex: '',
                regexExclude: '',
                lowerLimit: null,
                upperLimit: null,
                utilityProvider: false,
                switchDealAvailable: false,
                notRecurring: false,
                transactionClassification: null,
                setTransactionClassificationID: null
            });
        }
        function saveMerchantFn() {
            const merchantData = {
                ...selectedMerchant.value,
                name: editingData.name,
                regex: editingData.regex,
                regexExclude: editingData.regexExclude,
                lowerLimit: editingData.lowerLimit,
                upperLimit: editingData.upperLimit,
                utilityProvider: editingData.utilityProvider || false,
                switchDealAvailable: editingData.switchDealAvailable || false,
                notRecurring: editingData.notRecurring || false,
                setTransactionClassificationID: editingData.setTransactionClassificationID
            };
            admin.saveMerchant(merchantData, (saved) => {
                selectedMerchant.value = saved;
                selectMerchant(saved);
                loadMerchants();
                showToast('Merchant saved successfully');
            }, (error) => {
                showError(error);
            });
        }
        function deleteMerchantFn() {
            admin.deleteMerchant(selectedMerchant.value.id, () => {
                showDeleteConfirm.value = false;
                selectedMerchant.value = null;
                loadMerchants();
                showToast('Merchant deleted successfully');
            }, (error) => {
                showError(error);
            });
        }
        function reloadMerchant() {
            loadMerchants();
            admin.getEffectiveClassifications((result) => {
                transactionClassifications.value = result;
            });
            showToast('Reloaded');
        }
        function selectClassification(item) {
            const fullName = item.mgClassification + (item.mgSubClassification ? ', ' + item.mgSubClassification : '');
            editingData.transactionClassification = { ...item, fullName };
            editingData.setTransactionClassificationID = item.id;
            showClassifications.value = false;
        }
        onMounted(() => {
            loadMerchants();
            admin.getEffectiveClassifications((result) => {
                transactionClassifications.value = result;
            });
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", { class: "list-header" }, [
                            _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Merchants", -1)),
                            _createElementVNode("button", {
                                class: "action-btn primary",
                                onClick: createNewMerchant
                            }, "+ New")
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: "Search merchants...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, searchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (filteredMerchants.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMerchants.value, (merchant) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: merchant.id,
                                            class: _normalizeClass(["merchant-item", { active: selectedMerchant.value && selectedMerchant.value.id === merchant.id }]),
                                            onClick: ($event) => (selectMerchant(merchant))
                                        }, [
                                            _createElementVNode("img", {
                                                src: getBrandLogoUrl(merchant.name),
                                                class: "merchant-logo",
                                                onError: _cache[1] || (_cache[1] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                            }, null, 40, _hoisted_8),
                                            _createTextVNode(" " + _toDisplayString(merchant.name), 1)
                                        ], 10, _hoisted_7));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, " No merchants found "))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        (selectedMerchant.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    (editingData.name)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: getBrandLogoUrl(editingData.name),
                                            class: "detail-logo",
                                            onError: _cache[2] || (_cache[2] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                        }, null, 40, _hoisted_13))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(selectedMerchant.value.id || 'New Merchant'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: saveMerchantFn
                                    }, _toDisplayString(selectedMerchant.value.id ? 'Save Changes' : 'Create Merchant'), 1),
                                    (selectedMerchant.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "action-btn secondary",
                                            onClick: duplicateMerchant
                                        }, "Duplicate"))
                                        : _createCommentVNode("", true),
                                    (selectedMerchant.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "action-btn danger",
                                            onClick: _cache[3] || (_cache[3] = ($event) => (showDeleteConfirm.value = true))
                                        }, "Delete"))
                                        : _createCommentVNode("", true),
                                    (selectedMerchant.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            class: "action-btn secondary",
                                            onClick: reloadMerchant
                                        }, "Reload"))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "Name:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((editingData.name) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Regex:", -1)),
                                        _createElementVNode("div", _hoisted_18, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((editingData.regex) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingData.regex]
                                            ]),
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                disabled: !editingData.regex || testingRegex.value,
                                                onClick: testRegex
                                            }, _toDisplayString(testingRegex.value ? 'Testing...' : 'Test'), 9, _hoisted_19)
                                        ])
                                    ])
                                ]),
                                (regexMatches.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("label", null, _toDisplayString(regexMatches.value.length) + " matching transactions", 1),
                                        (regexMatches.value.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("table", _hoisted_22, [
                                                    _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "Merchant"),
                                                            _createElementVNode("th", null, "Description")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regexMatches.value, (row, i) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                                _createElementVNode("td", null, _toDisplayString(row.merchantName), 1),
                                                                _createElementVNode("td", null, _toDisplayString(row.description), 1)
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", null, [
                                            _createTextVNode(" Regex Exclude: "),
                                            _createElementVNode("span", {
                                                class: "tooltip-icon",
                                                title: "If the merchant matches the regex above but also matches this regex, it will be excluded from well known merchant matching."
                                            }, "?")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((editingData.regexExclude) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.regexExclude]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Lower Limit:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((editingData.lowerLimit) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.lowerLimit]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Upper Limit:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((editingData.upperLimit) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, editingData.upperLimit]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((editingData.utilityProvider) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, editingData.utilityProvider]
                                            ]),
                                            _cache[31] || (_cache[31] = _createTextVNode(" Utility "))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((editingData.switchDealAvailable) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, editingData.switchDealAvailable]
                                            ]),
                                            _cache[32] || (_cache[32] = _createTextVNode(" Switch Deal "))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((editingData.notRecurring) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, editingData.notRecurring]
                                            ]),
                                            _cache[33] || (_cache[33] = _createTextVNode(" Not Recurring "))
                                        ])
                                    ])
                                ]),
                                (discountString.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _cache[34] || (_cache[34] = _createElementVNode("label", null, "Voucher Available:", -1)),
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(discountString.value), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_34, [
                                    _cache[35] || (_cache[35] = _createElementVNode("label", null, "Classification:", -1)),
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("input", {
                                            value: editingData.transactionClassification ? editingData.transactionClassification.fullName : '',
                                            type: "text",
                                            class: "form-input",
                                            readonly: ""
                                        }, null, 8, _hoisted_36),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[12] || (_cache[12] = ($event) => (showClassifications.value = true))
                                        }, "Classify")
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_37, " Select a merchant to view details "))
                    ])
                ]),
                (showClassifications.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drawer-overlay",
                        onClick: _cache[15] || (_cache[15] = ($event) => (showClassifications.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "drawer",
                            onClick: _cache[14] || (_cache[14] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_38, [
                                _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Classifications", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[13] || (_cache[13] = ($event) => (showClassifications.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedClassifications.value, (group) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: group.name
                                    }, [
                                        (group.parent)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "cat-btn parent-cat",
                                                onClick: ($event) => (selectClassification(group.parent))
                                            }, _toDisplayString(group.name), 9, _hoisted_40))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(group.name), 1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (child) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: child.id,
                                                class: "cat-btn child-cat",
                                                onClick: ($event) => (selectClassification(child))
                                            }, _toDisplayString(child.mgSubClassification), 9, _hoisted_42));
                                        }), 128))
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "modal-overlay",
                        onClick: _cache[19] || (_cache[19] = ($event) => (showDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[18] || (_cache[18] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_43, [
                                _cache[37] || (_cache[37] = _createElementVNode("h3", null, "Delete Merchant", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[16] || (_cache[16] = ($event) => (showDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("p", null, [
                                    _cache[38] || (_cache[38] = _createTextVNode("Are you sure you want to delete ")),
                                    _createElementVNode("strong", null, _toDisplayString(selectedMerchant.value.name), 1),
                                    _cache[39] || (_cache[39] = _createTextVNode("?"))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: deleteMerchantFn
                                }, "Delete"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[17] || (_cache[17] = ($event) => (showDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[20] || (_cache[20] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[22] || (_cache[22] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
